// extracted by mini-css-extract-plugin
module.exports = {"Button":"animated-hamburger_Button__dM5WU","Line":"animated-hamburger_Line__ulXOd"};